"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarLayout = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const toolbar_layout_styles_1 = require("./toolbar-layout.styles");
const localization_1 = require("../../../../localization");
const ToolbarLayout = ({ enableMultiFiltering }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(ui_components_1.Toolbar, { render: () => (react_1.default.createElement(toolbar_layout_styles_1.StyledToolbarContent, null, react_1.default.createElement(ui_components_1.AppliedFiltersBar, { sortText: t({ key: 'SORT' }), sortDirectionText: {
                asc: t({ key: 'ASCENDING' }),
                desc: t({ key: 'DESCENDING' }),
            }, filtersText: t({ key: 'FILTERS' }), moreText: t({ key: 'MORE' }), collapseText: t({ key: 'COLLAPSE' }), clearText: t({ key: 'CLEAR' }), greaterThanText: t({ key: 'GREATER_THAN' }), lessThanText: t({ key: 'LESS_THAN' }) }), enableMultiFiltering && (react_1.default.createElement("div", null, react_1.default.createElement(ui_components_1.FilterPanelButton, { size: "medium", sx: {
                '& .MuiSvgIcon-root': {
                    fontSize: 24,
                },
            } }))))) }));
};
exports.ToolbarLayout = ToolbarLayout;
